import React from 'react';
import heroBg from '../../assets/hero-bg.jpg'; // Note: path changed because we are inside a folder
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="overlay"></div>
      <div className="hero-content container">
        <h1>Agri Supply Chain Solutions</h1>
        <p>Unlocking insights into complex commodity markets with Provenance expertise</p>
      </div>
      <div className="circle-lines"></div>
    </section>
  );
};

export default Hero;